import PoznamkaUpdate from './PoznamkaUpdate';

export default PoznamkaUpdate;
